module.exports = __webpack_public_path__ + "img/124.9.4911fca4.png";